import React, { useEffect, useRef, useState } from "react";
import styles from "./DecimalInput.module.scss";
const { input } = styles;
export interface IDecimalInputProps {
    value: string;
    disabled: boolean;
    numDecimals: number;
    max?: number;
    onChange: (newValue: string) => void;
}
const DecimalInput = (props: IDecimalInputProps) => {
    const [value, setValue] = useState(
        Math.floor(props.numDecimals) === 0 ? "0" : "0.0"
    );
    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const handleChange = (e: { target: { value: any } }) => {
        const inputValue = e.target.value;
        if (inputValue) {
            let regex;
            const numDecimals = Math.floor(props.numDecimals);
            if (!numDecimals || numDecimals === 0) {
                regex = /^\d*$/;
            } else {
                regex = new RegExp(`^\\d*\\.?\\d{0,${numDecimals}}$`);
            }
            if (!regex.test(inputValue)) {
                return;
            }
            if (props.max) {
                const num = parseFloat(inputValue);
                if (num > props.max) {
                    return;
                }
            }
        }

        setValue(inputValue);
        props.onChange(inputValue);
    };

    const handleBlur = () => {
        if (value) {
            const valString = value.toString();
            let v = valString;
            if (!valString.includes(".")) {
                v = valString + ".0";
            } else if (valString.endsWith(".")) {
                v = valString + "0";
            }
            setValue(v);
            props.onChange(v);
        }
    };

    const handleFocus = () => {
        if (inputRef.current) {
            inputRef.current.select();
        }
    };

    return (
        <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            className={input}
            disabled={props.disabled}
        />
    );
};

export default DecimalInput;
